import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3523fc27"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-auth" }

import SignUpBlock from "./components/SignUpBlock.vue";
import pPopup from '../common/pPopup/pPopup.vue'
import ProfileBlock from "@/authSection/components/ProfileBlock.vue";
import { useAuthPopup } from './store/authPopup'
import { onMounted } from "vue";
import { useClientStore } from "@/authSection/store/clientStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthSection',
  setup(__props) {

const authPopupStore = useAuthPopup()
const clientStore = useClientStore()

onMounted(() => {
  clientStore.setAuthStatus()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(clientStore).isAuth === false)
      ? (_openBlock(), _createBlock(SignUpBlock, { key: 0 }))
      : _createCommentVNode("v-if", true),
    (_unref(clientStore).isAuth)
      ? (_openBlock(), _createBlock(ProfileBlock, { key: 1 }))
      : _createCommentVNode("v-if", true),
    _createVNode(pPopup, {
      visible: _unref(authPopupStore).visible,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_unref(authPopupStore).visible = false))
    }, {
      content: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(authPopupStore).activeForm), { class: "form" }))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["visible"])
  ]))
}
}

})